import React from 'react';
import { ChoiceList, DisplayText } from '@superops/ui-design-system';
import { EnrollmentType } from '../types';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
interface EnrollmentTypeSelectorProps {
  enrollmentType: EnrollmentType[];
  onEnrollmentTypeChange: (types: EnrollmentType[]) => void;
}

const EnrollmentTypeSelector: React.FC<EnrollmentTypeSelectorProps> = ({
  enrollmentType,
  onEnrollmentTypeChange
}) => {
  return (
    <div className="flex actr g20">
      <div className="flex actr g10">
        <SVGIcon name="ReleaseNotes" />
        <div className="w200">
          <DisplayText size="large" isRequired>
            <FormattedMessage id="mdm.settings.EnrollDevice" />
          </DisplayText>
        </div>
      </div>
      <ChoiceList
        choices={[
          {
            label: <FormattedMessage id="mdm.policy.display.filter.fm" />,
            value: 'fully-managed'
          },
          { label: 'BYOD', value: 'BYOD' }
          // { label: 'KIOSK', value: 'KIOSK' }
        ]}
        selected={enrollmentType}
        onChange={(selected: string[]) =>
          onEnrollmentTypeChange(selected as EnrollmentType[])
        }
        horizontal
      />
    </div>
  );
};

export default EnrollmentTypeSelector;
